export default __webpack_public_path__ + "static/media/emoji-capsule.fa784013.svg";